import { render } from "./QrCode.vue?vue&type=template&id=6fbafb3c&scoped=true"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"

import "./QrCode.vue?vue&type=style&index=0&id=6fbafb3c&lang=scss&scoped=true"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbafb3c"]])

export default __exports__